export default __webpack_public_path__ + "62fac03f5c4e2a7f2d00ee6244f1cb0f.jpg";